<template>
  <div class="editor-section">
    <h3 class="blue-text">{{L10n('invoice-details')}}</h3>
    <div v-loading="isLoading">
      <form-item
        v-for="(item, i) in data"
        :key="item.id"
        :data="item"
        :itemID="item.id"
        :class="{'is-last': (data.length - 1) === i}"
      ></form-item>
      <div class="no-data section-no-data" v-if="!data.length">
        <span v-html="L10n('no-data-to-display')"/>
      </div>
    </div>
  </div>
</template>

<script>
import EditorSection from './EditorSection'
import { ServiceInvoice } from '@/services/Invoice'
export default {
  name: 'EditorInvoiceDetails',
  mixins: [EditorSection],
  components: {
    'form-item': () => import(/* webpackChunkName: 'Invoice' */ './InvoiceDetailItem')
  },
  props: {
    invoiceNumber: { required: true }
  },
  methods: {
    createPromiseRequest (callback, eventName) {
      return Promise.all(this.data.map((item) => {
        return new Promise((resolve, reject) => {
          const callback = function (result) {
            if (result instanceof Error) {
              reject(result)
            } else {
              resolve()
            }
          }
          this.$bus.$emit(`${eventName}-${item.id}`, callback)
        })
      }))
        .then(() => {
          callback()
        })
        .catch((err) => {
          callback(err)
        })
    },
    saveSection (callback) {
      return this.createPromiseRequest(callback, `Call-Invoice-Detail-Save`)
    },
    validateSection (callback) {
      return this.createPromiseRequest(callback, 'Call-Invoice-Detail-Validate')
    },
    handleRequestGetData (Data = []) {
      this.data = Data.reduce((result, item) => {
        if (item) result.push(Object.assign({}, item))
        return result
      }, [])
    },
    requestGetData () {
      if (!this.invoiceNumber || !this.mainID) {
        return
      }
      this.isLoading = true
      const params = {
        select: 'id,partID,partSN,qty,conditionID,price,currencyID,tagInfoCompanyID,tagDate,releaseID,remarks,chosen'
      }
      return ServiceInvoice
        .getInvoiceDetailsRFQ3({ invoiceNumber: this.invoiceNumber, rfqid: this.mainID, params })
        .then(({ data }) => {
          this.handleRequestGetData(data.value)
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="stylus">
  .section-no-data{
    &.no-data{
      position: relative
    }
  }
</style>
